import type { IBeeswaxEvent } from '@/Interfaces/Beeswax/Event.interface';
import type { IControlOption } from '@/Interfaces/ControlOption.interface';

export const beeswaxEventsToControlOptions = (beeswaxEvents: IBeeswaxEvent[]): IControlOption[] =>
  (beeswaxEvents ?? []).map(event => ({ label: event.eventName, value: event.id }));
